export default __webpack_public_path__ + "assets/_Chapters/Karriere/AusbildungUndStudium/thumbnail/gruppenfoto.webp";